import * as THREE from 'three'
import Experience from "../Experience.js";
import anim from '../Utils/Anim.js';
import vertex from '../../shaders/fire/vertex.glsl'
import fragment from '../../shaders/fire/fragment.glsl'

export default class Tableau5 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = _options.targetPos
        this.from6 = _options.from6



        this.setFire()
        this.mesh.visible = false; // Cache temporairement
        if (!this.from6) {
            requestAnimationFrame(() => {
                this.mesh.visible = true;
                this.material.uniforms.u_appear.value = 0;
                anim.to(this.material.uniforms.u_appear, {
                    value: 1,
                    duration: 1,
                });
            });
        } else {
            requestAnimationFrame(() => {
                this.mesh.visible = true;
                this.material.uniforms.u_appear.value = 0;
                this.material.uniforms.u_destroy.value = 1;
                anim.to(this.material.uniforms.u_destroy, {
                    value: 0,
                    duration: 3,
                    easing: 'power2.inout',
                });
                anim.to(this.material.uniforms.u_appear, {
                    value: 1,
                    duration: 1,
                });
            });
        }



    }
    setFire() {
        this.geometry = new THREE.PlaneGeometry(1, 1)
        this.material = new THREE.ShaderMaterial({
            transparent: true,
            depthTest: false,
            depthWrite: false,
            vertexShader: vertex,
            fragmentShader: fragment,
            uniforms: {
                u_res: new THREE.Uniform(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)),
                u_time: new THREE.Uniform(0),
                u_appear: new THREE.Uniform(0),
                u_destroy: new THREE.Uniform(0),
                u_noise: new THREE.Uniform(this.experience.ressources.items.noise)

            }

        })
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.rotation.y = Math.PI * 0.5
        this.mesh.rotation.x = Math.PI * 0.5
        this.mesh.lookAt(this.experience.camera.instance.position)
        this.mesh.position.set(this.targetPos.x - 5, this.targetPos.y, this.targetPos.z - 0.15)
        const distanceToCam = 16
        const fov = this.experience.camera.instance.fov * Math.PI / 180
        const scaleY = 2 * Math.tan(fov / 2) * distanceToCam
        const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
        this.mesh.scale.y = scaleY
        this.mesh.scale.x = scaleX
        // enable bloom on the mesh ? :
        this.mesh.layers.enable(1)
        this.scene.add(this.mesh)
    }

    destroy() {
        if (this.isDestroyed) return
        console.log();
        if (this.experience.router.path == '/chapitre6') {
            anim.to(this.material.uniforms.u_destroy, {
                value: 1,
                duration: 2,
                easing: 'power2.inout',
                onComplete: () => {
                    this.material.uniforms.u_appear.value = 0
                    anim.to(this.material.uniforms.u_appear, {
                        value: 0,
                        duration: 1,
                        onComplete: () => {
                            this.isDestroyed = true

                            this.scene.remove(this.mesh);

                            this.geometry.dispose();
                            this.material.dispose();

                            // Libère manuellement les uniforms s’ils contiennent des textures ou objets GPU
                            for (const key in this.material.uniforms) {
                                const uniform = this.material.uniforms[key];
                                if (uniform && uniform.value && typeof uniform.value.dispose === 'function') {
                                    uniform.value.dispose();
                                }
                            }

                            this.mesh = null;
                            this.geometry = null;
                            this.material = null;
                        }
                    })
                }
            })
        } else {

            anim.to(this.material.uniforms.u_appear, {
                value: 0,
                duration: 1,
                onComplete: () => {
                    this.isDestroyed = true
                    this.scene.remove(this.mesh);

                    this.geometry.dispose();
                    this.material.dispose();

                    // Libère manuellement les uniforms s’ils contiennent des textures ou objets GPU
                    for (const key in this.material.uniforms) {
                        const uniform = this.material.uniforms[key];
                        if (uniform && uniform.value && typeof uniform.value.dispose === 'function') {
                            uniform.value.dispose();
                        }
                    }

                    this.mesh = null;
                    this.geometry = null;
                    this.material = null;
                }
            })

        }




    }


    resize() {
        if (!this.isDestroyed) {
            this.material.uniforms.u_res.value.set(this.experience.sizes.width, this.experience.sizes.height)
            // resize mesh 
            const distanceToCam = 16
            const fov = this.experience.camera.instance.fov
            const scaleY = 2 * Math.tan(fov) * distanceToCam
            const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
            this.mesh.scale.y = scaleY
            this.mesh.scale.x = scaleX
        }

    }
    update() {
        if (!this.isDestroyed) {
            this.mesh.position.set(this.targetPos.x - 5, this.targetPos.y, this.targetPos.z - 0.15)
            this.mesh.lookAt(this.experience.camera.instance.position)
            this.material.uniforms.u_time.value = this.experience.time.elapsed * 0.001
            const distanceToCam = 16
            const fov = this.experience.camera.instance.fov * Math.PI / 180
            const scaleY = 2 * Math.tan(fov / 2) * distanceToCam
            const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
            this.mesh.scale.y = scaleY
            this.mesh.scale.x = scaleX

        }


    }
}